import { EDIT_SELECTED_VISIT, SHOW_NOTIFICATION } from "../constants";
import { axios } from "../connection/ConnectionHandler";
import { createCrudActions } from "../utils/crudGenerator";
import { getTemplateForVisit } from "../utils/templatePdf";
import { serializeVisitDates } from "../utils/visitSerializer";

const formatVisits = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) =>
    serializeVisitDates({
      ...item,
      label: item.name || item._id,
      value: item._id,
    });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchVisits,
  create: createVisit,
  update: updateVisit,
  delete: deleteVisits,
} = createCrudActions("VISIT", "Visita", formatVisits);

/** Abre el formulario de visita con payload serializable (sin Moment en Redux). */
export const editSelectedVisit = (visit) => ({
  type: EDIT_SELECTED_VISIT,
  payload: serializeVisitDates(visit),
});

export const signVisit = (visitId, signature) => async (dispatch, getState) => {
  try {
    const response = await axios.put(`/visit/${visitId}/signature`, {
      signature,
    });
    dispatch({
      type: "UPDATE_VISIT",
      payload: formatVisits(response.data),
    });
    const linkedTemplate = getTemplateForVisit(getState().templates, visitId);
    if (linkedTemplate) {
      dispatch({
        type: "UPDATE_TEMPLATE",
        payload: {
          ...linkedTemplate,
          signature: signature || null,
        },
      });
    }
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: {
        show: true,
        status: "success",
        message: signature
          ? "Firma guardada correctamente."
          : "Firma eliminada.",
      },
    });
    return response.status;
  } catch (err) {
    const message =
      err.response?.data?.message || "No se pudo guardar la firma.";
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: {
        show: true,
        status: "error",
        message,
      },
    });
    return err;
  }
};

export const sendVisitEmail =
  (visitId, message, templatePdf = null) => async (dispatch) => {
    try {
      const response = await axios.post(`/visit/${visitId}/send-email`, {
        message,
        templatePdf,
      });
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: {
          show: true,
          status: "success",
          message:
            response.data?.message ||
            `Correo enviado a ${response.data?.to || "el cliente"}.`,
        },
      });
      return response.status;
    } catch (err) {
      const message =
        err.response?.data?.message || "No se pudo enviar el correo.";
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: {
          show: true,
          status: "error",
          message,
        },
      });
      return err;
    }
  };
